import { EarlyWarningWatchlistService } from '@/modules/delinquency/services/early-warning-watchlist.service';

const service = new EarlyWarningWatchlistService();

const state = {
  watchlist: [],
  totalItems: 0,
  isLoading: false,
  error: null,
};

const actions = {
  async fetchWatchlist({ commit }, params) {
    commit('setLoading', true);
    try {
      const response = await service.getWatchlist(params);
      commit('setWatchlist', response.data);
      commit('setTotalItems', response.totalItems);
    } catch (error) {
      commit('setError', error);
    } finally {
      commit('setLoading', false);
    }
  },

  async createCaseFile({ commit }, loanId) {
    commit('setLoading', true);
    try {
      await service.createCaseFile(loanId);
    } catch (error) {
      commit('setError', error);
    } finally {
      commit('setLoading', false);
    }
  },
};

const mutations = {
  setWatchlist(state, watchlist) {
    state.watchlist = watchlist;
  },
  setTotalItems(state, totalItems) {
    state.totalItems = totalItems;
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setError(state, error) {
    state.error = error;
  },
};

export default {
  state,
  actions,
  mutations,
};